module.exports = __webpack_public_path__ + "static/media/2.30399267.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格未选中态/2.png
// module id = 1266
// module chunks = 0